<template>
  <v-app id="keep">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      app
    

    >
      <v-list
        dense
        
      >
        <v-tooltip right v-for="(item, i) in items" :key="i">
         
          <v-list-tile
            ripple
            slot="activator"
            @click='say(item.name,item.id,item.text,i)'
            :class="{active : i == actives}"
            
          >
        
            <v-list-tile-content>
            
              <v-list-tile-title >
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
        
          </v-list-tile>
          <span>{{item.text}}</span>
        </v-tooltip>

      </v-list>
    </v-navigation-drawer>

  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    flag: false,
    actives: null ,
    items: [
      {text: 'สถิติประชากร', name: 'FilterPage', id: 'statpop',active: 0},
      {text: 'สถิติประชากรและบ้าน', name: 'FilterPage', id: 'statpophse',active: 0},
      {text: 'สถิติบ้าน', name: 'FilterPage', id: 'stathouse',active: 2},
      {text: 'สถิติการเกิด', name: 'FilterPage', id: 'statbirth',active: 3},
      {text: 'สถิติการตาย', name: 'FilterPage', id: 'statdeath' },
      {text: 'สถิติการย้ายเข้า', name: 'FilterPage', id: 'statmovein',active: 4 },
      {text: 'สถิติการย้ายออก', name: 'FilterPage', id: 'statmoveout',active: 5 },
      // {text: 'สถิติการแก้ไขและจำหน่ายชื่อบุคคลโดย ทร.97 และ ทร.44', name: 'FilterPage', id: 'stat9744' },     
      // {text: 'สถิติการแก้ไขและเพิ่มชื่อบุคคลโดย ทร 14', name: 'FilterPage', id: 'stat14' },
      // {text: 'สถิติการแก้ไขและเพิ่มชื่อบุคคลโดย ทร.98', name: 'FilterPage', id: 'stat98' },
      //  {text: 'คู่มือระบบ', name: 'handbook', id: 'handbook'},
      {text: 'กลับเมนู', name: 'backmenu', id: 'backmenu',active: 6 },
    ]
  }),
  created () {

  },
  props: {
    source: String
  },
  methods: {
    // showselected(i){
    //  this.actives = i
    // },
     say (x, y, z, i) {
      // alert('TESTๆๆ'+x)
      // t
      this.actives = i
      this.$router.push({name: x })
      // this.$router.push({name: 'FilterPage' , params: {id: x}});
      if (y == 'backmenu') {
        //  this.$router.replace('https://iservices-ng.bora.dopa.go.th/menu/stat/#/')
        window.location.href = 'https://iservices-ng.bora.dopa.go.th/menu/stat/#/'
      } else if( y == 'handbook'){
         window.open('https://iservices-ng.bora.dopa.go.th/menu/stat/manual/statrealtime/STAT-REALTIME.pdf')
        // window.location.href = 'https://iservices-ng.bora.dopa.go.th/menu/stat/#/'
      }else {
        console.log(this.$router)
        let a = {name: x, params: {id: y, title: z, binfofil: 11, bmmyyb: '', bmmyye: ''}}
        this.$router.push(a)
      }
    }
  }
}
</script>